import permission from './modules/permission'

export default {
  permission
}



// WEBPACK FOOTER //
// ./src/store/modules.js